import { handleActions } from "redux-actions";
import {
    fetchActions,
    initialBaseState,
    IFetchStoreState,
    IResponse,
    updateProgressActions,
    IUpdateStoreState,
} from "./base-reducers";
import { ICoreUnlinkedMedia } from "constants/unlinked-media";
import { UNLINKED_MEDIA_PAGE_SIZE } from "actions/unlinked-media-actions";
import { UNLINKED_MEDIA } from "constants/action-types";

export type IUnlinkedMediaState = IFetchStoreState<ICoreUnlinkedMedia[]> & IUpdateStoreState<ICoreUnlinkedMedia[]>;
type FetchUpdateState<T> = IFetchStoreState<T> & IUpdateStoreState<T>;

const initialState: IUnlinkedMediaState = {
    ...initialBaseState,
    payload: [],
};

// prettier-ignore
export const unlinkedMedia = handleActions<FetchUpdateState<ICoreUnlinkedMedia[]>>(
    {
        ...updateProgressActions<IUnlinkedMediaState>(UNLINKED_MEDIA.LINK),
        ...fetchActions<IUnlinkedMediaState>(UNLINKED_MEDIA.FETCH),
        [UNLINKED_MEDIA.FETCH.SUCCESS]: (state: IUnlinkedMediaState, { payload }: IResponse<ICoreUnlinkedMedia[]>): IUnlinkedMediaState => {
            return {
                ...state,
                payload: [ ...state.payload, ...payload ],
                hasNextPage: payload?.length === UNLINKED_MEDIA_PAGE_SIZE,
                error: null,
                isFetching: false,
            };
        },
        [UNLINKED_MEDIA.LINK.SUCCESS]: (state: IUnlinkedMediaState): IUnlinkedMediaState => {
            return {
                ...state,
                error: null,
                isUpdating: false,
            };
        },
        [UNLINKED_MEDIA.RESET]: (): IUnlinkedMediaState => initialState,
    } as any,
    initialState
);
